// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__mVCF-","emptyLink":"NavigationItem_emptyLink__2ESO5","ComingSoonLabel":"NavigationItem_ComingSoonLabel__qK2YV"};